(function () {
  "use strict";

  // Quick, layout-free passes (no getComputedStyle, no offsetWidth reads).
  function setArrowLabels(root) {
    var nodes = root.querySelectorAll("button.juniper-new-arrow:not([aria-label])");
    for (var i = 0; i < nodes.length; i++) {
      var t = nodes[i];
      if (t.classList.contains("juniper-new-arrow-prev")) {
        t.setAttribute("aria-label", "Previous slide");
      } else if (t.classList.contains("juniper-new-arrow-next")) {
        t.setAttribute("aria-label", "Next slide");
      } else {
        t.setAttribute("aria-label", "Carousel navigation");
      }
    }
  }

  function setImageAlts(root) {
    var nodes = root.querySelectorAll("img:not([alt])");
    for (var i = 0; i < nodes.length; i++) {
      var t = nodes[i];
      var a = "";
      if (t.closest(".jdgm-card")) {
        a = "Customer review image";
      } else if (t.closest("#mintty-tiktok-feed")) {
        a = "TikTok product video preview";
      } else {
        var anchor = t.closest("a");
        if (anchor) {
          var txt = anchor.textContent.trim();
          if (txt) a = txt.slice(0, 80);
        }
      }
      t.setAttribute("alt", a);
    }
  }

  // Contrast pass — only runs once, deep in idle, batched read/write.
  // getComputedStyle forces style recalculation, so we keep it well after LCP
  // and guard with a single rAF write phase.
  function isLight(rgbStr) {
    var m = rgbStr && rgbStr.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+)/i);
    if (!m) return true;
    return (parseInt(m[1], 10) * 299 + parseInt(m[2], 10) * 587 + parseInt(m[3], 10) * 114) / 1000 > 186;
  }

  function fixContrastOnce() {
    var selector = ".jdgm-title,.jdgm-rating-text,.jdgm-reviews-count,.jdgm-verified-text,.jdgm-reviewer-name,.newsletter__heading,.section-newsletter p";
    var nodes = document.querySelectorAll(selector);
    if (!nodes.length) return;

    var updates = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cs = window.getComputedStyle(el);
      var bg = cs.backgroundColor || "rgb(255,255,255)";
      var fg = cs.color || "rgb(0,0,0)";
      var newColor = null;
      if (isLight(bg) && isLight(fg)) newColor = "#000";
      else if (!isLight(bg) && !isLight(fg)) newColor = "#fff";
      if (newColor) updates.push({ el: el, c: newColor });
    }

    if (updates.length) {
      requestAnimationFrame(function () {
        for (var j = 0; j < updates.length; j++) updates[j].el.style.color = updates[j].c;
      });
    }
  }

  function idle(fn, timeout) {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(fn, { timeout: timeout || 4000 });
    } else {
      setTimeout(fn, timeout || 1500);
    }
  }

  function quickPass() {
    setArrowLabels(document);
    setImageAlts(document);
  }

  function deepPass() {
    fixContrastOnce();
  }

  function start() {
    // Quick pass after load, when LCP is already painted.
    idle(quickPass, 2000);
    // Heavier contrast pass much later, well after LCP.
    idle(deepPass, 5000);
  }

  if (document.readyState === "complete") {
    start();
  } else {
    window.addEventListener("load", start, { once: true });
  }
})();
